import AppInfoResourceModel from '../../generated/types/model/resource/AppInfoResourceModel';

export default class AppInfoResourceViewModel extends AppInfoResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
